module.exports = __webpack_public_path__ + "static/media/fvs_valve1_57.68542d6b.jpg";